import { hasValue, toBool, toJSON, toNum, toStr } from "uxp/components";
export function operatorHasRValue(op) {
    return !(op == '$empty' || op == '$nempty');
}
export const filterConditionOperators = {
    "$eq": {
        label: "is equal to",
        value: '$eq'
    },
    "$ne": {
        label: "is not equal to",
        value: "$ne"
    },
    "$gt": {
        label: "is greater than",
        value: "$gt"
    },
    "$lt": {
        label: "is less than",
        value: "$lt"
    },
    "$gte": {
        label: "is greater than or equal",
        value: "$gte"
    },
    "$lte": {
        label: "is less than or equal",
        value: "$lte"
    },
    "$in": {
        label: "is in",
        value: '$in'
    },
    "$regex": {
        label: "matches expression",
        value: "$regex"
    },
    "$empty": {
        label: "is empty",
        value: "$empty"
    },
    "$nempty": {
        label: "is not empty",
        value: "$nempty"
    }
};
export const EmptyFilterCondition = {
    Attribute: '',
    Operator: "$eq",
    Value: ''
};
export const EmptyFilterConditionGroup = {
    All: false,
    Conditions: []
};
export function getInitialFilterConditions(filterConditions) {
    const filters = Object.assign({}, EmptyFilterConditionGroup);
    if (!!filterConditions) {
        filters.All = filterConditions.All;
        filters.Conditions = filterConditions.Conditions || [];
    }
    return filters;
}
function parseToArray(value) {
    if (Array.isArray(value)) {
        return value;
    }
    if (typeof value === 'string') {
        const _parsed = toJSON(value, null);
        if (!!_parsed)
            return _parsed;
        return value.split(',').map(item => item.trim());
    }
    return [];
}
export function convertToDataType(value, dataType) {
    switch (dataType) {
        case 'number':
            return toNum(value, 0);
        case 'boolean':
            return toBool(value, false);
        default:
            return toStr(value, '');
    }
}
export function isValidInputValue(value, dataType) {
    if (dataType == 'number')
        return /^\d+$/.test(value);
    if (dataType == 'boolean')
        return /^(true|false|1|0)$/i.test(value);
    return true;
}
export function getQueryFromFilterConditions(filters) {
    const query = {
        [filters.All ? '$and' : '$or']: []
    };
    if (filters.Conditions.length > 0) {
        const conditions = filters.Conditions.map((c, i) => {
            if (c.hasOwnProperty('All')) {
                // group
                return getQueryFromFilterConditions(c);
            }
            else {
                //condition 
                const { Attribute, Operator, Value, DataType } = c;
                // // TODO handle null, not null 
                // //  handle $in 
                // let parsedValue = getParsedValue(Value, DataType, Operator);
                //  convertToDataType(Value, DataType)
                // if (Operator == '$in') {
                //     if (!(String(parsedValue))?.trim()?.startsWith('{$')) {
                //         parsedValue = parseToArray(parsedValue)
                //     }
                // }
                return {
                    [Attribute]: {
                        [Operator]: Value
                    }
                };
            }
        });
        query[filters.All ? '$and' : '$or'] = conditions || [];
    }
    return query;
}
export function getFilterConditionsFromQuery(query) {
    // Handle null, undefined, or empty object cases
    if (!query || Object.keys(query).length === 0) {
        return Object.assign(Object.assign({}, EmptyFilterConditionGroup));
    }
    // Determine if the query is an OR condition
    const isAll = query.hasOwnProperty("$and");
    const conditionsArray = isAll ? query["$and"] : query["$or"];
    // Initialize conditions
    const conditions = [];
    // Iterate over each condition in the array
    conditionsArray === null || conditionsArray === void 0 ? void 0 : conditionsArray.forEach((item) => {
        if (item.hasOwnProperty("$or") || item.hasOwnProperty("$and")) {
            // Recursively convert nested groups
            conditions.push(getFilterConditionsFromQuery(item));
        }
        else {
            // Convert individual conditions
            if (Object.keys(item).length == 0)
                conditions.push(Object.assign({}));
            else {
                Object.keys(item).forEach(attribute => {
                    var _a;
                    const attrValue = item[attribute];
                    let operator = "$eq";
                    let value = '';
                    if (typeof attrValue == 'object') {
                        if (Object.keys(attrValue).length > 0) {
                            operator = ((_a = Object.keys(attrValue)) === null || _a === void 0 ? void 0 : _a[0]) || null;
                            value = !!operator ? attrValue[operator] : '';
                        }
                    }
                    else {
                        value = attrValue;
                    }
                    conditions.push({
                        Attribute: attribute,
                        Operator: operator || '$eq',
                        Value: value || '',
                        DataType: !!value ? typeof value : 'string'
                    });
                });
            }
        }
    });
    return {
        All: isAll,
        Conditions: conditions
    };
}
export function validateFilterConditions(query) {
    if (!query || typeof query !== 'object' || Array.isArray(query) || Object.keys(query).length == 0) {
        return {
            isValid: false,
            error: 'Atleast one condition is required'
        };
    }
    const filterConditions = getFilterConditionsFromQuery(query);
    const uniqueAttributes = new Set();
    function isConditionConfigured(condition) {
        if (hasValue(condition === null || condition === void 0 ? void 0 : condition.Attribute) && hasValue(condition === null || condition === void 0 ? void 0 : condition.Operator)) {
            // For $empty and $nempty operators, value is not required
            if (['$empty', '$nempty'].includes(condition.Operator)) {
                uniqueAttributes.add(condition.Attribute);
                return true;
            }
            // For other operators, value is required
            if (!!(condition === null || condition === void 0 ? void 0 : condition.Value)) {
                uniqueAttributes.add(condition.Attribute);
                return true;
            }
        }
        return false;
    }
    function isGroupConfigured(group) {
        return group.Conditions.every(c => {
            var _a;
            if (c.hasOwnProperty('All'))
                return ((_a = c.Conditions) === null || _a === void 0 ? void 0 : _a.length) > 0 && isGroupConfigured(c);
            else
                return isConditionConfigured(c);
        });
    }
    const isConfigured = isGroupConfigured(filterConditions);
    if (!isConfigured) {
        return {
            isValid: false,
            error: "All conditions needs be configured properly"
        };
    }
    const uniqueAttributesArray = Array.from(uniqueAttributes);
    return {
        isValid: true,
        uniqueAttributes: uniqueAttributesArray
    };
}
